import * as React from 'react';

export default () => (
  <svg width="10" height="10" fill="none">
    <g stroke="#F02929" strokeWidth="2" strokeLinecap="round">
      <path d="M1 1l8 8M9 1L1 9" />
    </g>
  </svg>
);
